module.exports = __webpack_public_path__ + "static/media/signout.56a42d29.svg";